export default __webpack_public_path__ + "c32e39e1e5774312de8eb9cd4a9decd3.png";